import React, { useState, useEffect } from "react"
import TitleStyled from "../components/styles/titleStyles"
import myInitObject from "../ultis/variable"
import DescriptionImageStyled from "../components/styles/DescriptionImageStyles"

const DescriptionImage = props => {
  const heading = props.data.settings.heading
  const description = props.data.settings.description
  const image = myInitObject.cockpitUrl + props.data.settings.image.path
  return (
    <section className="descriptionImage">
      <DescriptionImageStyled image={image}>
        <div className="half__wrapper">
          <div className="half__content half__content--left">
            <TitleStyled
              textAlign="center"
              linePosition="center"
              color="#000"
              lineColor="#000"
            >
              <h2>{heading}</h2>
            </TitleStyled>
            <p className="descrption">{description}</p>
          </div>
        </div>
        <div className="half__wrapper">
          <div className="half__content half__content--right"></div>
        </div>
      </DescriptionImageStyled>
    </section>
  )
}

export default DescriptionImage
